import { Box, Heading, HStack, Text, VStack } from '@chakra-ui/react';
import type { FC, PropsWithChildren } from 'react';
import { useMedia } from 'react-use';
import { Image } from '~/common/components/image';
import { Color, Media } from '~/utils/styles/enums';

type Props = PropsWithChildren<{
  icon: {
    src: string;
    alt: string;
  };
  sectionTitle: String;
  anchorId: string;
}>;

const PCLayout: FC<Props> = ({ icon, sectionTitle, anchorId, children }) => {
  return (
    <HStack
      spacing="30px"
      marginTop="60px"
      alignItems="flex-start"
      flexDir="row"
    >
      <Image src={icon.src} alt={icon.alt} w={'150px'} />
      <VStack w="full" alignItems="flex-start">
        <Heading as="h2" id={anchorId}>
          {sectionTitle}
        </Heading>
        <Text color={Color.ACCENT_700} fontSize="16px">
          {children}
        </Text>
      </VStack>
    </HStack>
  );
};

const MobileBanner: FC<Props> = ({ icon, sectionTitle, children }) => {
  return (
    <VStack>
      <Heading
        as="h2"
        pb="10px"
        textAlign="left"
        width="100%"
        borderBottom={`1px solid ${Color.SEPARATOR}`}
      >
        {sectionTitle}
      </Heading>
      <Box>
        <Image
          src={icon.src}
          alt={icon.alt}
          w={'100px'}
          mr="15px"
          float="left"
        />
        <Text color={Color.ACCENT_700} fontSize="15px" display="inline">
          {children}
        </Text>
      </Box>
    </VStack>
  );
};

export const WithIconContent: FC<Props> = (props) => {
  const isLarge = useMedia(Media.LARGE, true);
  return isLarge ? <PCLayout {...props} /> : <MobileBanner {...props} />;
};
